import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum DeviceType {
  Mobile = 'Mobile',
  Tablet = 'Tablet',
  Desktop = 'Desktop'
}

@Injectable({
  providedIn: 'root'
})

export class DeviceDetectorService {

  private deviceTypeSubject = new BehaviorSubject<DeviceType>(this.getDeviceType());
  deviceType$ = this.deviceTypeSubject.asObservable();

  constructor() {
    window.addEventListener('resize', this.onResize.bind(this));
  }

  private getDeviceType(): DeviceType {
    const width = window.innerWidth;
    if (width <= 600) {
      return DeviceType.Mobile;
    } else if (width > 600 && width <= 1024) {
      return DeviceType.Tablet;
    } else {
      return DeviceType.Desktop;
    }
  }

  private onResize() {
    const newDeviceType = this.getDeviceType();
    this.deviceTypeSubject.next(newDeviceType);
  }

  public getCurrentDeviceType(): DeviceType {
    return this.deviceTypeSubject.getValue();
  }
}
